import React from 'react'
import { Dimensions } from 'components/MeasurementUnit'
import ArtworkDescriptionConnector, {
  ConnectorProps as ArtworkDescriptionProps,
} from '../../../connectors/ArtworkDescription'
import {
  ORIGINAL,
  ROLLED,
  FLAT_CRATE,
  ROLLED_IN_TUBE,
  BOX,
  CRATE,
} from '../../../helpers/constants'
import { getPanelTitle } from '../../../helpers/product'
import InfoTitleValue from '../components/InfoTitleValue/InfoTitleValue'
import styles from '../ArtworkDescription.module.scss'
import { capitalizeString } from 'lib/helpers'

const OriginalProductDetails = (props: ArtworkDescriptionProps) => {
  const {
    category,
    mediums,
    materials,
    currentTab,
    dimensions,
    packingOption,
    readyToHangStatus,
    frameStatus,
    isAple,
    unitsProduced,
    isMultiPanel,
    panels,
    isOutdoor,
  } = props
  const panelTitle = getPanelTitle(category)
  const shouldShowPanels = category !== 'Video' && panels > 1
  const isPrintmaking = category === 'Printmaking'

  const getPackagingType = () => {
    if (packingOption === ROLLED) {
      return ROLLED_IN_TUBE
    } else if (packingOption === FLAT_CRATE) {
      return CRATE
    } else return BOX
  }

  if (currentTab !== ORIGINAL) {
    return null
  }

  return (
    <div className={styles.artworkInfoGrid}>
      <div className={styles.artworkInfoGridContainer}>
        <InfoTitleValue
          title='Medium:'
          value={`${isMultiPanel ? 'Multi-paneled ' : ''}${
            isAple && isPrintmaking ? 'Print' : category
          }, ${mediums.length && mediums[0]} on ${materials.length && materials[0]}`}
          isTwoColumns={true}
        />
        <InfoTitleValue
          title='Rarity:'
          value={isAple ? `Limited Edition of ${unitsProduced}` : 'One-of-a-kind Artwork'}
          isTwoColumns={true}
        />

        {dimensions && (
          <InfoTitleValue
            title='Size:'
            value={<Dimensions dimensions={dimensions} />}
            isTwoColumns={true}
          />
        )}

        {shouldShowPanels && (
          <InfoTitleValue title={`${panelTitle}:`} value={panels} isTwoColumns={true} />
        )}

        <InfoTitleValue
          title='Ready to Hang:'
          value={capitalizeString(readyToHangStatus)}
          isTwoColumns={true}
        />
        <InfoTitleValue title='Frame:' value={frameStatus} isTwoColumns={true} />
        <InfoTitleValue title='Authenticity:' value='Certificate is Included' isTwoColumns={true} />
        <InfoTitleValue title='Packaging:' value={getPackagingType()} isTwoColumns={true} />
        {isOutdoor !== null && (
          <InfoTitleValue title='Outdoor Safe:' value={isOutdoor ? 'Yes' : 'No'} isTwoColumns={true} />
        )}
      </div>
    </div>
  )
}

export default ArtworkDescriptionConnector(OriginalProductDetails)
